import { ConversationItem } from "@accurx/api/clinician-messaging";
import { Conversation } from "domains/concierge/types";

export const mapConversationItemIdentityToConversationItemId = (
    identity: Pick<ConversationItem, "id" | "type">,
): Conversation["id"] => {
    return `cmi-${identity.type}-${identity.id}`;
};
